import axios from 'axios';

const apiConfig = axios.create({
  baseURL: process.env.NX_API_URL, // YOUR_API_URL HERE
  headers: {
    'Access-Control-Allow-Origin': '*',
  },
});

export default apiConfig;
